import { render, staticRenderFns } from "./vue-good-wizard.vue?vue&type=template&id=42c47f22&scoped=true"
import script from "./vue-good-wizard.vue?vue&type=script&lang=js"
export * from "./vue-good-wizard.vue?vue&type=script&lang=js"
import style0 from "./vue-good-wizard.vue?vue&type=style&index=0&id=42c47f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c47f22",
  null
  
)

export default component.exports